<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Register User for Customer '{{CustomerName}}'</h5>


      <form [formGroup]="CustomerUser" (submit)="SubmitCustomerUser()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6" *ngIf="!CurrentUserName">
              <label for="exampleInputEmail1">Username</label>
              <input formControlName="Username" type="text" class="form-control"  placeholder="Type here...">
              <small *ngIf="!get_Form_Username().valid && get_Form_Username().touched" class="form-text text-muted MyErrorRedColor">Enter the username.</small>
          </div>
          <div class="form-group col-md-6" *ngIf="CurrentUserName">
            <label for="exampleInputEmail1">Username</label>
            <input disabled value="{{CurrentUserName}}" formControlName="Username" type="text" class="form-control"  placeholder="Type here...">
        </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Password</label>
            <input formControlName="Password" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Password().valid && get_Form_Password().touched" class="form-text text-muted MyErrorRedColor">Enter a password of at least 6 characters.</small>
          </div>
        </div>


        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!CustomerUser.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
        <button routerLink="/Customer" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>
